module.exports = __webpack_public_path__ + "static/media/29BDOS3.1e6ccc3e.jpg";